module.exports = __webpack_public_path__ + "img/indexBg.ec225c4e.png";